import { useState } from "react";

import { Banknote, BarChart4, CreditCard } from "lucide-react";

import { BankTransactionsList } from "~/components/BankTransactionsList";
import { Overview } from "~/components/Overview";
import { CalendarDateRangePicker } from "~/components/date-range-picker";
import { MainNav } from "~/components/main-nav";
import { RecentSales } from "~/components/recent-sales";
import { Search } from "~/components/search";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "~/components/ui/tabs";
import { UserNav } from "~/components/user-nav";
import { useCurrentUser } from "~/hooks/useCurrentUser";

export function FinanceDashboard() {
  const [activeTab, setActiveTab] = useState("overview");
  const { user } = useCurrentUser();

  return (
    <div className="flex min-h-screen flex-col">
      <div className="border-b">
        <div className="flex h-16 items-center px-4">
          <MainNav className="mx-6" />
          <div className="ml-auto flex items-center space-x-4">
            <Search />
            <UserNav />
          </div>
        </div>
      </div>
      <div className="flex-1 space-y-4 p-8 pt-6">
        <div className="flex items-center justify-between space-y-2">
          <h2 className="text-3xl font-bold tracking-tight">Finanzas</h2>
          <div className="flex items-center space-x-2">
            <CalendarDateRangePicker />
            {/* <Button size="sm" variant="outline">
              <RefreshCcw className="mr-2 h-4 w-4" />
              Actualizar
            </Button> */}
          </div>
        </div>
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList>
            <TabsTrigger value="overview">
              <BarChart4 className="mr-2 h-4 w-4" />
              Resumen
            </TabsTrigger>
            <TabsTrigger value="bank-transactions">
              <Banknote className="mr-2 h-4 w-4" />
              Transacciones Bancarias
            </TabsTrigger>
            <TabsTrigger value="payments">
              <Banknote className="mr-2 h-4 w-4" />
              Pagos
            </TabsTrigger>
          </TabsList>
          <TabsContent value="overview" className="space-y-4">
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
              <Card>
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                  <CardTitle className="text-sm font-medium">
                    Ingresos Totales
                  </CardTitle>
                  <Banknote className="h-4 w-4 text-muted-foreground" />
                </CardHeader>
                <CardContent>
                  <div className="text-2xl font-bold">$45.231.890</div>
                  <p className="text-xs text-muted-foreground">
                    +20.1% desde el mes pasado
                  </p>
                </CardContent>
              </Card>
              <Card>
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                  <CardTitle className="text-sm font-medium">
                    Pagos Pendientes
                  </CardTitle>
                  <CreditCard className="h-4 w-4 text-muted-foreground" />
                </CardHeader>
                <CardContent>
                  <div className="text-2xl font-bold">$12.345.678</div>
                  <p className="text-xs text-muted-foreground">
                    -4% desde el mes pasado
                  </p>
                </CardContent>
              </Card>
              <Card>
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                  <CardTitle className="text-sm font-medium">
                    Transacciones Pendientes
                  </CardTitle>
                  <Banknote className="h-4 w-4 text-muted-foreground" />
                </CardHeader>
                <CardContent>
                  <div className="text-2xl font-bold">7</div>
                  <p className="text-xs text-muted-foreground">
                    +5 desde el mes pasado
                  </p>
                </CardContent>
              </Card>
              <Card>
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                  <CardTitle className="text-sm font-medium">
                    Transacciones Completadas
                  </CardTitle>
                  <Banknote className="h-4 w-4 text-muted-foreground" />
                </CardHeader>
                <CardContent>
                  <div className="text-2xl font-bold">42</div>
                  <p className="text-xs text-muted-foreground">
                    +12 desde el mes pasado
                  </p>
                </CardContent>
              </Card>
            </div>
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-7">
              <Card className="col-span-4">
                <CardHeader>
                  <CardTitle>Resumen</CardTitle>
                </CardHeader>
                <CardContent className="pl-2">
                  <Overview />
                </CardContent>
              </Card>
              <Card className="col-span-3">
                <CardHeader>
                  <CardTitle>Ventas Recientes</CardTitle>
                  <CardDescription>
                    Se han procesado 42 transacciones este mes.
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <RecentSales />
                </CardContent>
              </Card>
            </div>
          </TabsContent>
          <TabsContent value="bank-transactions">
            <Card>
              <CardHeader>
                <CardTitle>Transacciones Bancarias</CardTitle>
                <CardDescription>
                  Administre y vincule transacciones bancarias a pagos de
                  clientes.
                </CardDescription>
              </CardHeader>
              <CardContent className="pl-2">
                <BankTransactionsList />
              </CardContent>
            </Card>
          </TabsContent>
          <TabsContent value="payments">
            <Card>
              <CardHeader>
                <CardTitle>Pagos</CardTitle>
                <CardDescription>
                  Historial de pagos realizados por los clientes.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p>Lista de pagos aquí...</p>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
